export default "__VITE_ASSET__hyJs0ZR1__"